import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb07765e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cb07765e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb07765e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserInfoBox: require('/drone/src/components/UserInfoBox/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default})
